import React, { Fragment } from 'react';
import { CTMInvoiceForm, CTMInvoiceResult, CTMModal } from '~/components';
import { connect } from 'react-redux';
import { sso2Lightning } from '~/redux/sso';
import { toggleAsideMenu } from '~/redux/application';
import { TripType, getProfileToken, getError, getTripType, animate, ThemeType, ErrorCode, config, DownloadInvoiceStatus, InvoiceResultMode } from '~/common';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import BaseWidget from '../../components/BaseWidget';
import { Breadcrumb, Button, message, Modal, Table } from 'antd';
import { store } from '~/index.js';
import { searchTravelerSummary, SearchInvoice, DownloadInvoice, DownloadInvoicesZip, RequestDownloadInvoice, SearchDownloadInvoice } from '~/client';
import { prepareMeta, formatDate, convertDate } from '../PreTrip/helpers';
import moment from 'moment';


class CTMInvoice extends React.Component {
    constructor(props) {
        super()
        this.state = {
            searchParam: {
                travelDateFrom: formatDate(moment().add(-3, 'months')),
                travelDateTo: '',
                travelerProfileSourceIds: [],
                invoiceNo: '',
                companyId: null,
                pageSize: config.invoicePageSize,
                pageIndex: 1,
                profileToken: getProfileToken(),
                companyName: '',
                travelerId: '',
                travelerName: '',
                isTravelDate: true
            },
            dataSource: [

            ],
            travelDateTo: '',
            companyDataSource: [],
            travelDataSource: [],
            count: 0,
            searchLoading: false,
            customerCode: '',
            downloadInvoiceNo: [],
            isModelVisable: false,
            downloadInvoiceParam: {},
            activeTab: 'invoices',//invoices background_downloads
            bgDownloadInvoices: [],
            searchDownloadInvoiceLoading: false,
        }
    }

    componentWillMount() {
        if (this.props.location && this.props.location.state) {
            this.handleSearchParamChange(this.props.location.state);
        }
        let companyDataSource = store.getState().user.viewCompanies;
        this.setState({ companyDataSource: companyDataSource })
        this.mounted = true;
    }
    componentWillUnmount() {
        this.mounted = false;
        window.clearTimeout(this.searchDownloadInvoiceTimeoutId);
    }
    componentDidMount() {
        this.mounted = true;
        if (this.props.location && this.props.location.state) {
            this.handleSearchParamChange(this.props.location.state);
            this.handleSubmit('', this.props.location.state);
        }
    }
    fm = (id, values) => this.props.intl.formatMessage({ id }, values);

    handleSearch = (val, id) => {
        const params = {
            SearchKeyword: val,
            companyId: id,
            profileToken: getProfileToken(),
            TravelerIdType: 'ProfileSourceId',
            includeDummy: true,
            IgnoreUserDummyRestrictions: true,
            PageInfo: {
                PageIndex: this.state.pageIndex,
                PageSize: this.state.pageSize
            }

        };
        searchTravelerSummary(params, (_, rs) => {
            if (!this.mounted) return;
            let dataSource = [];
            if (rs && rs.summaryInfos && rs.summaryInfos.length > 0) {
                dataSource = rs.summaryInfos.map(({ code, displayName }) => ({ travelerId: code, travelerName: displayName }));
            }
            this.setState({ travelDataSource: dataSource, searchLoading: false });
        });
    }

    handleConfirmDownload = () => {
        if (this.props.enableDownloadInvoiceAsync) {
            this.handleConfirmDownloadAsync();
            return;
        }
        var param = this.state.downloadInvoiceParam
        this.setState({ isModelVisable: false });
        const tid = setTimeout(() => {
            this.setState({ searchLoading: false })
        }, 3000)
        DownloadInvoicesZip(param, (_, rs) => {
            if (!this.mounted) return;
            window.clearTimeout(tid);
            if (rs != null) {
                if (rs.msg) {
                    message.warn(rs.msg);
                } else {
                    const link = document.createElement('a');
                    link.style.display = 'none';
                    link.href = URL.createObjectURL(rs);
                    link.download = 'Invoice-' + moment().format('YYYYMMDDhhmmss') + '.zip';
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                    URL.revokeObjectURL(link.href)
                }

            }
            this.setState({ searchLoading: false, downloadInvoiceNo: [], downloadInvoiceParam: {} })
        })
    }


    handleDownload = (val) => {
        if (this.props.enableDownloadInvoiceAsync) {
            this.handleDownloadAsync(val);
            return;
        }
        var param = {
            InvoiceNo: val.InvoiceNo,
            CustomerCode: val.CustomerCode,
            FollowupCompany: val.FollowupCompany,
            profileToken: getProfileToken(),
        };
        if (this.state.downloadInvoiceNo.length > 0 && !this.state.downloadInvoiceNo.includes(val.InvoiceNo)) {
            return
        }
        this.setState({ searchLoading: true })
        if (this.state.downloadInvoiceNo.length > 1) {
            let paramList = { profileToken: param.profileToken, DownloadInvoices: [] };
            this.state.downloadInvoiceNo.forEach(inv => {
                paramList.DownloadInvoices.push({ InvoiceNo: inv, CustomerCode: param.CustomerCode, FollowupCompany: param.FollowupCompany })
            })
            this.setState({ isModelVisable: true, downloadInvoiceParam: paramList })
        } else {

            if (this.state.downloadInvoiceNo.length == 1) {
                param.InvoiceNo = this.state.downloadInvoiceNo[0];
            }
            const tid = setTimeout(() => {
                this.setState({ searchLoading: false })
            }, 3000)
            DownloadInvoice(param, (_, rs) => {
                if (!this.mounted) return;
                window.clearTimeout(tid);
                if (rs != null) {
                    if (rs.msg) {
                        message.warn(rs.msg);
                    } else {
                        const link = document.createElement('a');
                        link.style.display = 'none';
                        link.href = URL.createObjectURL(rs);
                        link.download = param.InvoiceNo + '.pdf';
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link)
                        URL.revokeObjectURL(link.href)
                    }

                }
                this.setState({ searchLoading: false, downloadInvoiceNo: [] })
            })
        }
    }

    handleConfirmDownloadAsync = () => {
        var param = this.state.downloadInvoiceParam
        this.setState({ isModelVisable: false });
        const tid = window.setTimeout(() => {
            this.setState({ searchLoading: false })
        }, 3000)
        RequestDownloadInvoice(param, (_, rs) => {
            if (!this.mounted) return;
            window.clearTimeout(tid);
            this.setState({ searchLoading: false })
            const errMsg = getError(rs);
            if (errMsg) {
                CTMModal.error({
                    className: 'ctm-modal-no-close-icon',
                    centered: true,
                    content: errMsg,
                });
                return;
            }
            this.setState({ downloadInvoiceNo: [], downloadInvoiceParam: {}, activeTab: 'background_downloads' });
            this.handleSearchDownloadInvoice();
        });
    }

    handleDownloadAsync = (val) => {
        var param = {
            InvoiceNo: val.InvoiceNo,
            CustomerCode: val.CustomerCode,
            FollowupCompany: val.FollowupCompany,
            profileToken: getProfileToken(),
        };
        let downloadInvoiceNo = this.state.downloadInvoiceNo;
        if (downloadInvoiceNo.length > 0 && !downloadInvoiceNo.includes(val.InvoiceNo)) {
            return
        }
        if (downloadInvoiceNo.length == 0) {
            downloadInvoiceNo = [val.InvoiceNo];
        }
        this.setState({ searchLoading: true })
        let paramList = { profileToken: param.profileToken, DownloadInvoices: [] };
        downloadInvoiceNo.forEach(inv => {
            paramList.DownloadInvoices.push({ InvoiceNo: inv, CustomerCode: param.CustomerCode, FollowupCompany: param.FollowupCompany })
        })
        this.setState({ isModelVisable: downloadInvoiceNo.length > 1, downloadInvoiceParam: paramList })
        if (downloadInvoiceNo.length == 1) {
            window.setTimeout(() => this.handleConfirmDownload(), 300);
        }
    }

    handleSearchDateTo = (param) => {
        this.setState({ travelDateTo: param })
    }
    handleClearTraveler = () => {
        this.setState({ travelDataSource: [] })
    }
    handleSearchParamChange = (param) => {
        this.setState({ searchParam: param });
    }
    handleSubmit = (e, parParam, pageIndex = 1) => {
        e && e.preventDefault();
        if (!parParam) {
            parParam = this.state.searchParam;
            const { searchParam } = this.state;
            searchParam.pageIndex = pageIndex;
            this.setState({ searchParam: searchParam })
        }
        let searchParams = {
            issueDateFrom: "",
            issueDateTo: "",
            travelDateFrom: "",
            travelDateTo: "",
            travelerProfileSourceIds: parParam.travelerProfileSourceIds,
            invoiceNo: parParam.invoiceNo,
            pageSize: parParam.pageSize,
            pageIndex: parParam.pageIndex,
            profileToken: parParam.profileToken,
            companyId: parParam.companyId
        };
        if (parParam.isTravelDate) {
            searchParams.travelDateFrom = parParam.travelDateFrom;
            searchParams.travelDateTo = parParam.travelDateTo;
        } else {
            searchParams.issueDateFrom = parParam.travelDateFrom;
            searchParams.issueDateTo = parParam.travelDateTo;
        }
        if (!searchParams.companyId) {
            for (let inputParent of [...document.getElementsByClassName('cN')]) {
                let inputRequire = inputParent.getElementsByTagName('input')[0];
                inputRequire.click();
            }
        } else {
            if (this.props.isWidgets) {
                this.props.history.push('/invoices', this.state.searchParam);
                return;
            }
            setTimeout(() => {
                this.setState({ searchLoading: true })
            })
            if (searchParams.travelDateTo) {
                searchParams.travelDateTo = formatDate(convertDate(searchParams.travelDateTo).add(+1, 'days'))
            }
            if (searchParams.issueDateTo) {
                searchParams.issueDateTo = formatDate(convertDate(searchParams.issueDateTo).add(+1, 'days'))
            }
            SearchInvoice(searchParams, (_, rs) => {
                if (!this.mounted) return;
                let data = [];
                if (rs && rs.Documents) {
                    rs.Documents.map((x, i) => {
                        let temp = x;
                        temp.key = i + 1;
                        data.push(temp)

                    })
                    this.setState({ dataSource: data, count: rs.RecordCount, searchLoading: false, downloadInvoiceNo: [] })
                } else {
                    this.setState({ dataSource: [], count: 0, searchLoading: false, downloadInvoiceNo: [] })
                }
            })
        }
    }

    handleDownloadInv = (param) => {
        this.setState({ downloadInvoiceNo: param });
    }

    handleApply = () => {
        const selectedRows = this.state.dataSource.filter(v => this.state.downloadInvoiceNo.includes(v.InvoiceNo));
        if (!selectedRows.length) {
            message.warn(this.fm('please_select_invoice_apply'));
            return;
        }
        this.props.onApply && this.props.onApply(selectedRows);
    }

    handleSearchDownloadInvoice() {
        if (this.state.searchDownloadInvoiceLoading) return;
        var param = {
            profileToken: getProfileToken(),
        };
        this.setState({ searchDownloadInvoiceLoading: true });
        window.clearTimeout(this.searchDownloadInvoiceTimeoutId);
        SearchDownloadInvoice(param, (_, rs) => {
            if (!this.mounted) return;
            this.setState({ bgDownloadInvoices: rs.DownloadInvoices, searchDownloadInvoiceLoading: false });
            if ((rs.DownloadInvoices || []).some(v => [DownloadInvoiceStatus.Pending, DownloadInvoiceStatus.Processing].includes(v.Status))) {//auto refreshing every 5 seconds
                this.searchDownloadInvoiceTimeoutId = window.setTimeout(() => this.handleSearchDownloadInvoice(), 5000);
            }
        })
    }

    handleDownloadInvoice(item) {
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = item.FileUrl;
        link.download = item.FileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    render() {
        const { searchParam, dataSource, count, companyDataSource, travelDataSource, searchLoading, downloadInvoiceNo, activeTab, bgDownloadInvoices, searchDownloadInvoiceLoading } = this.state;
        const { enableDownloadInvoiceAsync } = this.props;
        const isApplyMode = this.props.mode === InvoiceResultMode.ApplyVouchers;
        return (
            <Fragment>
                {!this.props.isWidgets && <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Breadcrumb className='breadcrumb'>
                        <Breadcrumb.Item className='breadcrumb-item'><FormattedMessage id='invoices' /></Breadcrumb.Item>
                    </Breadcrumb>
                    {!isApplyMode && enableDownloadInvoiceAsync && <div className='inv-tabs-dv'>
                        <button className={`inv-tab${activeTab == 'invoices' ? ' active' : ''}`} onClick={() => this.setState({ activeTab: 'invoices' })}>{this.fm('invoices')}</button>
                        <button className={`inv-tab${activeTab == 'background_downloads' ? ' active' : ''}`} onClick={() => {
                            this.setState({ activeTab: 'background_downloads' });
                            this.handleSearchDownloadInvoice();
                        }}>{this.fm('background_downloads')}</button>
                    </div>}
                </div>}


                {(isApplyMode || activeTab == 'invoices') && <div className='fare-forecaster test trips-container invFrom'>

                    <CTMInvoiceForm
                        searchParam={searchParam}
                        handleSearchParamChange={this.handleSearchParamChange}
                        handleSubmit={this.handleSubmit}
                        intl={this.props.intl}
                        handleSearch={this.handleSearch}
                        companyDataSource={companyDataSource}
                        travelDataSource={travelDataSource}
                        handleClearTraveler={this.handleClearTraveler}
                        handleSearchDateTo={this.handleSearchDateTo}
                        isWidgets={this.props.isWidgets}></CTMInvoiceForm>
                    {!this.props.isWidgets && <CTMInvoiceResult
                        dataSource={dataSource}
                        count={count}
                        searchParam={searchParam}
                        handleSearchParamChange={this.handleSearchParamChange}
                        handleSubmit={this.handleSubmit}
                        intl={this.props.intl}
                        handleDownload={this.handleDownload}
                        searchLoading={searchLoading}
                        downloadInvoiceNo={downloadInvoiceNo}
                        handleDownloadInv={this.handleDownloadInv}
                        mode={isApplyMode ? InvoiceResultMode.ApplyVouchers : undefined}
                        onApply={isApplyMode ? this.handleApply : undefined}
                        applying={this.props.applying}
                    ></CTMInvoiceResult>}
                </div>}

                {!isApplyMode && activeTab == 'background_downloads' && <div className='inv-downloads trips-container'>
                    <div className='caption'>{this.fm('background_downloads')}</div>
                    <div className='hint'>{this.fm('background_downloads_tips')}</div>
                    <Table dataSource={bgDownloadInvoices}
                        columns={[
                            {
                                title: this.fm('requested_at'),
                                dataIndex: 'RequestedAt',
                            },
                            {
                                title: this.fm('total_invoices'),
                                dataIndex: 'TotalInvoices',
                            },
                            {
                                title: this.fm('status'),
                                dataIndex: 'StatusRemark',
                                render: (_, record) => {
                                    return <div className={`badge status-${record.Status}`}>{record.StatusRemark}</div>;
                                }
                            },
                            {
                                title: this.fm('estimated_time_remaining'),
                                dataIndex: 'EstimatedTimeRemaining',
                                render: (_, record) => {
                                    return <div>{record.EstimatedTimeRemaining > 0 ? `${record.EstimatedTimeRemaining}s` : '——'}</div>;
                                }
                            },
                            {
                                title: this.fm('expire_date'),
                                dataIndex: 'ExpireDate',
                            },
                            {
                                title: this.fm('actions'),
                                align: 'right',
                                render: (_, record) => {
                                    return <div>{record.FileUrl ? <button className='ctm-btn ctm-tile-btn ctm-btn-xs' onClick={() => this.handleDownloadInvoice(record)}>{this.fm('download')}</button> : record.Status == DownloadInvoiceStatus.Failed ? <></> : <button className='ctm-btn ctm-tile-btn ctm-btn-xs' disabled='disabled'>{this.fm('preparing')}...</button>}</div>;
                                }
                            }
                        ]}
                        pagination={false}
                        rowKey={'Id'}
                        loading={!(bgDownloadInvoices || []).length && searchDownloadInvoiceLoading}
                    />

                </div>}

                {!isApplyMode && <Modal
                    title={<FormattedMessage id='download_pdf' />}
                    visible={this.state.isModelVisable}
                    closable={false}
                    centered={true}
                    destroyOnClose={true}
                    footer={[
                        <Button key="back" onClick={() => { this.setState({ isModelVisable: false, searchLoading: false, downloadInvoiceParam: {} }) }}>
                            <FormattedMessage id='cancel'></FormattedMessage>
                        </Button>,
                        <Button key="submit" type="primary" onClick={() => this.handleConfirmDownload()}>
                            <FormattedMessage id='ok'></FormattedMessage>
                        </Button>,
                    ]}
                >
                    <p><FormattedMessage id='batch_donwnload_zip' /></p>
                </Modal>}
            </Fragment>

        )
    }
}

export default connect(state => ({
    isLightMode: state.userSetting.ThemeType === ThemeType.Breezy,
    defaultDepartureCity: state.userData.DefaultDepartureCity,
    searchTimeoutMinutes: state.application.sessionTimeoutMinutes,
    enableDownloadInvoiceAsync: state.user.enableDownloadInvoiceAsync,
}), dispatch => ({
    sso2Lightning: payload => dispatch(sso2Lightning(payload)),
    toggleAsideMenu: payload => dispatch(toggleAsideMenu(payload)),
}))(injectIntl(withRouter(BaseWidget(CTMInvoice))));